import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { Auth } from 'aws-amplify';

function Login() {
    const redirectToHostedUI = async () => {
        try {
            // Redirects to Cognito Hosted UI
            await Auth.federatedSignIn();
        } catch (error) {
            console.error('Error during login:', error);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box className="login-container" textAlign="center" mt={5}>
                <Typography variant="h4" gutterBottom>
                    Welcome to NMOPS Portal
                </Typography>
                {/* <Typography variant="body1" gutterBottom>
                    Please log in with your Microsoft account.
                </Typography> */}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={redirectToHostedUI}
                    style={{ marginTop: '20px' }}
                >
                    Login with Microsoft
                </Button>
            </Box>
        </Container>
    );
}

export default Login;


// function Login() {
//     useEffect(() => {
//         const redirectToHostedUI = async () => {
//             try {
//                 await Auth.federatedSignIn(); // Redirects to Cognito Hosted UI
//             } catch (error) {
//                 console.error('Error during login:', error);
//             }
//         };

//         redirectToHostedUI();
//     }, []);

//     return (
//         <Container maxWidth="sm">
//             <Typography variant="h4" gutterBottom>
//                 Redirecting to login...
//             </Typography>
//         </Container>
//     );
// }
